import styled from "styled-components";

const Input = styled.input`
  width: 100%;
  border: 0;
  padding: 5px 5px;
  border-bottom: 2px solid #ececec;
  margin-bottom: 15px;
  color: #333;
  font-size: 1em;
`;

export default Input;
